import React from 'react';

import { About, Footer, Header, Skills, Testimonial, Work } from './container';
import { Navbar } from './components';
import { LanguageProvider } from './context/LanguageContext';
import './App.scss';

const App = () => (
  <LanguageProvider>
    <div className="app">
      <Navbar />
      <Header />
      <About />
      <Work />
      <Skills />
      <Testimonial />
      <Footer />
    </div>
  </LanguageProvider>
);

export default App;
